module.exports = __webpack_public_path__ + "static/media/used-tires-red.caf531b9.svg";